import Link from "next/link";
import { CustomVariantItemProps, MinProductItemProps } from "../Product/constants";
import OurPick from "../Utils/OurPick"
import { PromoteProps } from "./constants"


interface CenterTemplateProps extends PromoteProps {
  setSelectProduct: (product: MinProductItemProps) => void;
  selectedCustomVariant: CustomVariantItemProps | null;
  setSelectedCustomVariant: (variant: CustomVariantItemProps | null) => void;
  fromName: string;
  setFromName: (value: string) => void;
  toName: string;
  setToName: (value: string) => void;
  toEmail: string;
  setToEmail: (value: string) => void;
  toMobile: string;
  setToMobile: (value: string) => void;
  toMessage: string;
  setToMessage: (value: string) => void;
  pregnancy: string;
  setPregnancy: (value: string) => void;
  duDate: Date | null;
  setDuDate: (value: Date | null) => void;
  childName: string;
  setChildName: (value: string) => void;
  childAge: number | null;
  setChildAge: (value: number | null) => void;
  childGender: string;
  setChildGender: (value: string) => void;
  viewport: string;
}

const CenterTemplate = (props: CenterTemplateProps) => {

  return (
    <div className="py-10 bg-centerPromotionTemplateBg font-poppins">
      <div className={`${props.viewport === "mobile" ? "container" : ""} text-center mb-12`}>
        <h3 className="text-xl font-semibold text-promotionTitle">{props.name}</h3>
        <p className="mt-2 text-sm text-promotionDesc" dangerouslySetInnerHTML={{__html: props.desc.replace(/(?:\r\n|\r|\n)/g, "<br />")}}></p>
      </div>
      <div className="md:container">
        <OurPick
          tittle=""
          link={null}
          image={null}
          banner_list={[]}
          product_list={props.products}
          attrId={null}
          customName={null}
          expandColor={false}
          showBorder={false}
          setSelectProduct={props.setSelectProduct}
          selectedCustomVariant={props.selectedCustomVariant}
          setSelectedCustomVariant={props.setSelectedCustomVariant}
          fromName={props.fromName}
          setFromName={props.setFromName}
          toName={props.toName}
          setToName={props.setToName}
          toEmail={props.toEmail}
          setToEmail={props.setToEmail}
          toMobile={props.toMobile}
          setToMobile={props.setToMobile}
          toMessage={props.toMessage}
          setToMessage={props.setToMessage}
          pregnancy={props.pregnancy}
          setPregnancy={props.setPregnancy}
          duDate={props.duDate}
          setDuDate={props.setDuDate}
          childName={props.childName}
          setChildName={props.setChildName}
          childAge={props.childAge}
          setChildAge={props.setChildAge}
          childGender={props.childGender}
          setChildGender={props.setChildGender}
          customMarginTop="mt-10"
        />
      </div>
      <div className="container justify-center hidden mt-8 md:flex">
        <Link href={props.promotion_url}>
          <button
            className="px-4 py-2 text-sm font-semibold text-white rounded-lg bg-mooimom"
          >
            Show More
          </button>
        </Link>
      </div>
    </div>
  )
}

export default CenterTemplate
